export default class General {
    static init() {
        General.handleHashLinks();
		General.setAppHeight();
        General.setScrollbarWidth();
    }
    static setScrollbarWidth() {
        const getScrollbarWidth = () => {
            // Creating invisible container
            const outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.overflow = 'scroll';
            outer.style.msOverflowStyle = 'scrollbar';
            document.body.appendChild(outer);

            // Creating inner element and placing it in the container
            const inner = document.createElement('div');
            outer.appendChild(inner);

            // Calculating difference between container's full width and the child width
            const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

            // Removing temporary elements from the DOM
            outer.parentNode.removeChild(outer);

            return scrollbarWidth;
        }

        document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`)
    }

	static setAppHeight() {
		const appHeight = () => {
			document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
		}
		window.addEventListener('resize', appHeight);
		appHeight();
	}

    static handleHashLinks() {
        const urlParams = new URLSearchParams(location.search);
        const hash = location.hash || (urlParams.has('go') ? '#' + urlParams.get('go') : null)
        if(hash && document.querySelector(hash)) {
            General.scrollTo(document.querySelector(hash));
        }

        window.addEventListener('DOMContentLoaded', () => {
            let element = hash ? document.querySelector(hash) : null;
            if (!hash || !element) return;

            General.scrollTo(element);
        });

        window.addEventListener('click', e => {
            let link = e.target ? e.target.closest('a') : null;
            if (!link) return;
            let hash = link.href.replace(location.href.replace(location.hash, ''), '');
            if(!hash || hash === '#' || !hash.startsWith('#')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            General.scrollTo(document.querySelector(hash));
            let newHref = location.href.replace(location.hash, '');
            history.replaceState({}, '', newHref + hash);
        });
    }

    static scrollTo(targetElement) {
        if (!targetElement) return;
        let gap = 15;
        let headerElement = document.querySelector('.header');
        let headerHeight = headerElement ? headerElement.offsetHeight : 0;
        let targetPosition = targetElement ? (targetElement.getBoundingClientRect().top + window.scrollY) : false;

        window.scrollTo({
            behavior: 'smooth',
            top: targetPosition - headerHeight - gap
        });
    }
}
